import { useEffect } from "react";
import { TopLevelDialogNames } from "@/components/TopLevelDialogs";
import useFeatureFlags from "./useFeatureFlags";
import useDialog from "./useDialog";

const useJobMatchVideoTaskHandler = () => {
  const {
    flags: { jobMatchVideoPopUP },
  } = useFeatureFlags();
  const { openTopLevelDialog } = useDialog();

  useEffect(() => {
    if (jobMatchVideoPopUP) {
      openTopLevelDialog(TopLevelDialogNames.jobMatchVideo);
    }
  }, [jobMatchVideoPopUP]);
};

export default useJobMatchVideoTaskHandler;
